import PropTypes from 'prop-types';
import moment from 'moment';
import Error from '../../../pages/_error';
import List from './components/list';

const formatDate = (date) => moment(date).fromNow();

const LangProvider = (props) => {
  const { posts, isLoading, hasError, loadNextPage, hasNextPage } = props;

  if (hasError) {
    return <Error />;
  }

  return (
    <List
      posts={posts}
      hasNextPage={hasNextPage}
      loadNextPage={loadNextPage}
      isLoading={isLoading}
      formatDate={formatDate}
    />
  );
};

LangProvider.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  loadNextPage: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
};

export default LangProvider;
